import {
    apiClient as api
} from './APIService'

export const userAlreadyExists = (email) => {
    return api.get('user/' + email);
}